<template>

  <div> 
    <Loader v-if="loading"/>
  	 <div class="app-main-layout" v-else>
      
        <Navbar @click="isOpen=!isOpen"/>


        <Sidebar v-model="isOpen" :key="locale"/>
        

        <main class="app-content" :class="{full: !isOpen}">
          <div class="app-page">
            <router-view />
 
        </div>
        </main>

          <div class="fixed-action-btn">
            <router-link class="btn-floating btn-large blue" to="/record" href="#" v-tooltip="'Создать новую запись'">
              <i class="large material-icons">add</i>
            </router-link>
          </div>
        </div>
      </div>
      </template>
      

      <script>
        import Navbar from '@/components/app/Navbar'
        import Sidebar from '@/components/app/Sidebar'
        import messages from '@/utils/messages'

       export default{
        name: 'main-layout',
        data:()=>({
          isOpen: true,
          loading: true
        }),
        async mounted(){ //маунти ассинк иначе авейт не возможен
          //лучше все делать в методе маунтед 9/2,28
          //когда стартует мейн лайаут это значит что система сейчас загружается и будем делать этот запрос
          //запрос на получение данных о пользователе
          if(!Object.keys(this.$store.getters.info).length){  //проверяем если объкт пустой то тогда делаем запрос. если значение 0 делаем запрос
           await this.$store.dispatch('fetchInfo')
           //будет делать асинхр забпр поэтому добавля авайт
          }

          this.loading = false

        },
        components:{
          Navbar, Sidebar
        },
        computed: {
    error() {
      // показывание ошибок. получает доступ до ошибок в геттерах
      return this.$store.getters.error
      //когда что-то меняется в еррорах будет обновляться это компьютед свойство. и когда оно измениться нужно отследить этот момент с помощью вотч где говорим за каким полем надо следить
    },
    locale() {
      return this.$store.getters.info.locale
    }
  },
  watch: {
    // locale() {
    //   console.log('Locale changed')
      
    // },
    error(fbError) {
      console.log(fbError)
      //еррор в формате файербайз еррор
      this.$error(messages[fbError.code] || 'Что-то пошло не так')
      //обащается к совйству $error котрое вызывает сообщение об ошибке и передаем сюда объект меседжес с ключем [fbError.code] и если ничего не найдено  8/18,50
    }
  }


    
        }
      </script>
     